import addNewClause from './addNewClause';
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
export default action('initializeInboxRuleEdit')(function initializeInboxRuleEdit(ruleToEditId) {
    if (store.inboxRulesEditState.conditionalClauseIds.length == 0) {
        addNewClause('conditional', null, null);
    }
    if (store.inboxRulesEditState.actionClauseIds.length == 0) {
        addNewClause('action', null, null);
    }
});
//# sourceMappingURL=initializeInboxRuleEdit.js.map